import React from 'react';
import { Info } from 'lucide-react';
import { Highlight } from './Highlight';
import { MockWindow } from './MockWindow';
const sections = [{
  heading: 'Tax details',
  name: 'Leslie Outreach, Inc.',
  lines: ['Nonprofit organization · United States']
}, {
  heading: 'Business details',
  name: 'Business information',
  lines: ['leslieoutreach.org', '210 E. Bellevue Street, Leslie, MI']
}, {
  heading: 'Products or services',
  name: 'Category',
  lines: ['Charities or social service organizations']
}];
export function ReviewMockup() {
  return <MockWindow data-id="element-155" data-mp="3pdlmhgycp73g">
      <div className="px-[3cqw] py-[1.6cqw]" data-id="element-156" data-mp="3pe4xedpl2v7z">
        <div className="w-[34cqw]" data-id="element-157" data-mp="3pfy2vpogn9ee">
          <p className="text-[1.5cqw] font-semibold text-mm-black" data-id="element-158" data-mp="3ke8smc92azrd">Review and submit</p>
          <p className="mt-[0.6cqw] flex items-center gap-[0.6cqw] border border-mm-light-gray px-[0.8cqw] py-[0.5cqw] text-[1cqw] text-mm-muted-charcoal" data-id="element-159" data-mp="28w2licwr6s4">
            <Info className="h-[1.1cqw] w-[1.1cqw] shrink-0" aria-hidden="true" data-id="element-160" data-mp="3th9xyaq3smtz" />
            You won't be able to submit until you complete all sections.
          </p>
          {sections.map(section => <div key={section.heading} className="mt-[0.9cqw]" data-id="element-161" data-mp="2etes9k6im6cj">
              <p className="text-[1.05cqw] font-semibold text-mm-black" data-id="element-162" data-mp="2jpdkjiuys8i8">{section.heading}</p>
              <div className="mt-[0.3cqw] flex items-start justify-between border border-mm-light-gray px-[0.8cqw] py-[0.6cqw]" data-id="element-163" data-mp="2oqjh5rrqwfx1">
                <div data-id="element-164" data-mp="2sqtlkzzw2y9s">
                  <p className="text-[1cqw] font-semibold text-mm-charcoal" data-id="element-165" data-mp="2sp91k4b7axq6">{section.name}</p>
                  {section.lines.map(line => <p key={line} className="text-[1cqw] text-mm-mid-gray" data-id="element-166" data-mp="32hy0y0th8l55">
                      {line}
                    </p>)}
                </div>
                <Highlight tone="go" data-id="element-167" data-mp="3cfcg7x3nz3vv">
                  <span className="block border border-mm-light-gray px-[0.6cqw] text-[1cqw] font-medium text-mm-charcoal" data-id="element-168" data-mp="3cgds23si7uen">
                    Edit
                  </span>
                </Highlight>
              </div>
            </div>)}
          <Highlight tone="go" tag="Click last" className="mt-[1.4cqw]" data-id="element-169" data-mp="1cctfgjnv0q66">
            <div className="flex h-[2.4cqw] items-center justify-center bg-[#635BFF] text-[1.05cqw] font-semibold text-white" data-id="element-170" data-mp="1cenzzwv7yg9q">
              Agree and submit
            </div>
          </Highlight>
        </div>
      </div>
    </MockWindow>;
}